import { render } from "./FollowNotificationItem.vue?vue&type=template&id=249410d6&scoped=true&ts=true"
import script from "./FollowNotificationItem.vue?vue&type=script&lang=ts"
export * from "./FollowNotificationItem.vue?vue&type=script&lang=ts"

import "./FollowNotificationItem.vue?vue&type=style&index=0&id=249410d6&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-249410d6"]])

export default __exports__